module.exports = __webpack_public_path__ + "img/mcgl_tyg_03.fdb2be70.png";